import { gql } from "graphql-tag";

gql`
    query toc($filter: ContentMapFilter, $paths: [String!], $first: NonNegativeInt!, $after: String!) {
        contentMaps(filter: $filter, filterOptions: { includeHidden: true }) {
            contentMaps(first: 1) {
                node {
                    id
                    contentId
                    toc(paths: $paths) {
                        total {
                            count
                            countRelation
                        }
                        tocEntries(first: $first, after: $after) {
                            id
                            path
                            cursor
                            childPath
                            hasChildren
                            node {
                                id
                                teasers {
                                    title(length: 256)
                                }
                                ... on Topic {
                                    url
                                    mimeType
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

gql`
    query tocPathAndTitle($rootContentId: ID, $contentId: ID) {
        contentInContext(rootContentId: $rootContentId, contentId: $contentId) {
            path
            id
            childPath
            hasChildren
            next {
                id
                teasers {
                    title(length: 256)
                }
            }
            previous {
                id
                teasers {
                    title(length: 256)
                }
            }
            node {
                id
                contentId
                locale
                version
                ... on ContentMap {
                    versionLabel
                    version
                }
                ... on Topic {
                    url
                    mimeType
                    teasers {
                        title(length: 256)
                    }
                    version
                    useContext {
                        rootContentMap {
                            id
                            contentId
                            version
                            versionLabel
                        }
                    }
                }
            }
        }
    }
`;

gql`
    query contentsSearch($filter: ContentFilter, $first: NonNegativeInt) {
        contents(filter: $filter) {
            contents(first: $first) {
                cursor
                highlights {
                    title(length: 256)
                    text(length: 256)
                    __typename
                }
                node {
                    id
                    contentId
                    locale
                    ... on ContentMap {
                        type

                        teasers {
                            title(length: 256)
                            __typename
                        }
                        __typename
                    }
                    ... on Topic {
                        type
                        teasers {
                            title(length: 256)
                            __typename
                        }
                        mimeType
                        __typename
                    }
                    __typename
                }
            }
            total {
                count
                countRelation
            }
        }
    }
`;

export const getQueryTopicIsAllowedInContext = (
    productId: string | undefined,
    assetId: string | undefined,
    mechanicId: string | undefined
) => {
    const contentFragment = `relatedContents(filter: $filter) {
        contents {
            node {
                id
            }
        }
    }`;

    if (mechanicId) {
        const query = `query topicIsAllowedInContext($mechanicId: String!, $filter: ContentFilter!) {
            mechanic(id: $mechanicId) {
                id
                ${contentFragment}
            }
        }`;
        return gql(query);
    }

    if (assetId) {
        const query = `query topicIsAllowedInContext($assetId: String!, $filter: ContentFilter!) {
            asset(id: $assetId) {
                id
                ${contentFragment}
            }
        }`;
        return gql(query);
    }

    if (productId) {
        const query = `query topicIsAllowedInContext($productId: String!, $filter: ContentFilter!) {
            product(id: $productId) {
                id
                ${contentFragment}
            }
        }`;
        return gql(query);
    }

    return undefined;
};
